<div class="full_background">
  <div class="background auth-panel">
    <mat-list class="">
      <br>
      <br>
      <mat-list-item class="centralizing">
        <img src="../../../../../assets/images/logoEstiWhite.svg" height="50px" class="esty-logo-padding">
      </mat-list-item>
      @if (tenantLogoUrl) {
      <mat-list-item class="centralizing mapfre-logo-row">
        <img [src]="tenantLogoUrl" height="30px" alt="Tenant logo">
      </mat-list-item>
      }

      <br>
      <br>
      <br>

      <h4 class="lightColor centralizing">{{variables.authentication}}</h4>

      <br>

      @if (showPasswordLoginForm) {
      <!-- User/password mode on generic login, or tenant login when SSO is disabled. -->
      <form [formGroup]="loginForm" (keydown.enter)="submitLogin()">

        <mat-list-item class="auth-field-row">
          <mat-form-field appearance="fill" class="auth-input-field">
            <mat-label>Email</mat-label>
            <input matInput formControlName="emailCtrl" type="email">
            @if (mailInvalid) {
            <mat-hint class="mat-error">{{mailErrorMessage}}</mat-hint>
            }
          </mat-form-field>
        </mat-list-item>

        <br>

        <mat-list-item class="auth-field-row">
          <mat-form-field appearance="fill" class="auth-input-field">
            <mat-label>Password</mat-label>
            <input matInput formControlName="passwordCtrl" type="password">
            @if (paswordInvalid) {
            <mat-hint class="mat-error">{{passErrorMessage}}</mat-hint>
            }
          </mat-form-field>
        </mat-list-item>


        @if (isLoading) {
        <app-circular-loader [primary]="false" class="centerLoader"></app-circular-loader>
        }


        @if (!isLoading) {
        <mat-list-item class="centralizing btn-margin auth-button-row">
          <div class="auth-button-wrap">
            <app-button typeBtn="secondary" [width]="'fit-content'" (click)="submitLogin()" message={{variables.enter}}>
            </app-button>
          </div>
        </mat-list-item>
        }
      </form>
      }

      @if (showSsoLoginButton) {
      <!-- SSO button on generic login, or tenant login when SSO is enabled. -->
      @if (!isLoading) {
      <mat-list-item class="centralizing btn-margin auth-button-row">
        <div class="auth-button-wrap">
          <app-button typeBtn="secondary" [width]="'fit-content'" (click)="signInWithSso()"
            [message]="variables?.signInWithSso || 'Sign in with SSO'"></app-button>
        </div>
      </mat-list-item>
      }
      }

      <div class="btn-margin">
        @if (errorDetected) {
        <app-error-message [errorMsg]="errorText"></app-error-message>
        }
      </div>

    </mat-list>
  </div>
  <div class="background image-panel">
    <img [src]="loginBackgroundImageUrl" alt="Login background">
  </div>


  <mat-nav-list class="langStyle">
    @if (variables && variables.language) {
    <mat-list-item (click)="actionDiv(openDiv)" class="sidenav-menu-list-item ">
      <div class="item-container" matTooltip="{{ variables.language }}">
        <mat-icon svgIcon="ISO" style="width:25px; height:25px;"></mat-icon>
        <h4 class="menu-item" mat-line>
          <mat-icon class="trans-span" style="margin: 0;">arrow_drop_down</mat-icon>
        </h4>
      </div>
    </mat-list-item>
    }

    @if (openDiv) {
    <div>
      @if (variables && variables.language) {
      <mat-list-item (click)="changeLanguage('pt')" style="width: 100%;"
        class="sidenav-menu-list-item mat-list-new-div">
        <div class="row row-style">
          <div class="col-3 col-3-style">
            <span class="fi fi-pt"></span>
          </div>
          <div class="col-9">
            <h5>{{variables.portuguese}}</h5>
          </div>
        </div>
      </mat-list-item>
      }
      @if (variables && variables.language) {
      <mat-list-item (click)="changeLanguage('es')" style="width: 100%;"
        class="sidenav-menu-list-item mat-list-new-div">
        <div class="row row-style">
          <div class="col-3 col-3-style">
            <span class="fi fi-es"></span>
          </div>
          <div class="col-9">
            <h5>{{variables.spanish}}</h5>
          </div>
        </div>
      </mat-list-item>
      }
      @if (variables && variables.language) {
      <mat-list-item (click)="changeLanguage('en')" style="width: 100%;"
        class="sidenav-menu-list-item mat-list-new-div">
        <div class="row row-style">
          <div class="col-3 col-3-style">
            <span class="fi fi-gb"></span>
          </div>
          <div class="col-9">
            <h5>{{variables.english}}</h5>
          </div>
        </div>
      </mat-list-item>
      }
    </div>
    }
  </mat-nav-list>



</div>